import React, { useState } from 'react';
import { FiPlusCircle, FiMinusCircle, FiRefreshCw } from 'react-icons/fi';
import axios from 'axios';
import './InteractiveParagraph.css';
import { useTranslation } from 'react-i18next';

const InteractiveParagraph = ({ content, onUpdateParagraph, paragraphId }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleAction = async (action) => {
        setIsLoading(true);
        try {
            const response = await axios.post('https://ai.kesifaraci.com/service/api/paragraph/modify', {
                paragraph: content,
                action: action
            });

            if (response.data.result) {
                onUpdateParagraph(response.data.data.text, paragraphId);
            }
        } catch (error) {
            console.error('Error modifying paragraph:', error);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return <div className="loading-paragraph" />;
    }

    return (
        <div className="paragraph-container">
            <div className="paragraph-controls">
                <button
                    className="control-button"
                    onClick={() => handleAction('expand')}
                    title="Metni Genişlet"
                >
                    <FiPlusCircle size={18} />
                </button>
                <button
                    className="control-button"
                    onClick={() => handleAction('shorten')}
                    title="Metni Kısalt"
                >
                    <FiMinusCircle size={18} />
                </button>
                <button
                    className="control-button"
                    onClick={() => handleAction('refresh')}
                    title="Metni Yeniden Yaz"
                >
                    <FiRefreshCw size={18} />
                </button>
            </div>
            <div className="paragraph-content" dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    );
};

export default InteractiveParagraph;